import styled from '@emotion/styled'
import Subtitle from '@molecules/Subtitle'

export const BodyWrapper = styled.div`
  position: relative;
  padding: 24px 0 18px;
`

export const SectionTitle = styled(Subtitle)`
  font-size: 14px;
  line-height: 16px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.black};
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 400;
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 0 10px 17px;
`

export const SectionHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const ChapterWrapper = styled.div<{ isDragging?: boolean }>`
  margin-bottom: ${({ theme }) => theme.sizes.threeBase};
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};
  transition: opacity 0.2s;
  border-bottom: 1px solid ${({ theme }) => theme.colors.disable};
  padding: 10px 0;
`

export const ChapterHeader = styled.div<{ expanded: boolean; isEditable?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 16px;
  padding: 0;
  background: transparent;
  border-radius: 0;
  cursor: pointer;
  transition: background 0.2s;
  border-bottom: none;

  &:hover {
    background: transparent;
  }
`

export const ChapterLeftContent = styled.div`
  display: flex;
  align-items: center;
  gap: 0;
  min-width: 0;
`

export const DragHandle = styled.span`
  color: #c7c7c7;
  cursor: grab;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;

  &:active {
    cursor: grabbing;
  }

  .anticon {
    display: none;
  }

  &::before {
    content: '';
    display: block;
    width: 11px;
    height: 5px;
    border-top: 1px solid currentColor;
    border-bottom: 1px solid currentColor;
  }
`

export const ChapterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  flex: 0 0 auto;
`

export const ChapterTitle = styled.span<{ $expanded?: boolean }>`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: ${({ $expanded, theme }) =>
    $expanded ? theme.colors.main : theme.colors.text.black};
  text-align: left;
  overflow-wrap: anywhere;
`

export const ChapterArrow = styled.span<{ expanded: boolean }>`
  transform: rotate(${({ expanded }) => (expanded ? '180deg' : '0deg')});
  transition: transform 0.2s;
  color: ${({ expanded, theme }) =>
    expanded ? theme.colors.main : theme.colors.text.secondary};
  font-size: 10px;
  line-height: 1;
  margin-left: 5px;
`

export const ChapterDragHandle = styled(DragHandle)`
  width: 14px;
  height: 16px;
  margin: 0 10px;
`

export const ThemesWrapper = styled.div`
  padding: 20px 0 0;
  border: none;
  border-radius: 0;
`

export const ThemesTitle = styled.div`
  margin: 30px 10px;
  color: ${({ theme }) => theme.colors.text.black};
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 400;
`

export const ThemeItem = styled.div<{ isDragging?: boolean }>`
  display: flex;
  align-items: flex-end;
  padding: 0;
  margin-bottom: ${({ theme }) => theme.sizes.twoBase};
  font-size: 14px;
  line-height: 14px;
  border-bottom: none;
  opacity: ${({ isDragging }) => (isDragging ? 0.5 : 1)};
  transition: opacity 0.2s;

  &:last-child {
    border-bottom: none;
  }
`

export const ThemeDragHandle = styled.span`
  color: #dedede;
  cursor: grab;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 10px;
  height: 14px;
  margin: 0 10px;
  flex: 0 0 auto;

  &:active {
    cursor: grabbing;
  }

  .anticon {
    display: none;
  }

  &::before {
    content: '';
    display: block;
    width: 8px;
    height: 4px;
    border-top: 1px solid currentColor;
    border-bottom: 1px solid currentColor;
  }
`

export const ThemeTitle = styled.span`
  color: ${({ theme }) => theme.colors.text.black};
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  min-width: 0;
  overflow-wrap: anywhere;
  cursor: pointer;
  text-align: left;
`

export const ThemeTitleGroup = styled.div`
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 0;
  min-width: 0;
`

export const ThemeActions = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  margin-left: 15px;
  flex: 0 0 auto;
`

export const FinalTestRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 16px;
  padding: 10px 0;
  margin-bottom: ${({ theme }) => theme.sizes.threeBase};
  background: transparent;
  border-bottom: 1px solid ${({ theme }) => theme.colors.disable};
`

export const FinalTestLeftContent = styled(ChapterLeftContent)``

export const FinalTestTitleGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  min-width: 0;
  cursor: pointer;
`

export const AddThemeButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.disable};
  color: ${({ theme }) => theme.colors.text.black};
  border-radius: 20px;
  cursor: pointer;
  font-size: 11px;
  line-height: 16px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  padding: 0 16px;
  min-height: 38px;
  margin-top: 4px;
  margin-left: 0;

  &:hover {
    background: ${({ theme }) => theme.colors.background.surface};
    border-color: ${({ theme }) => theme.colors.main};
  }
`

export const ActionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
  padding-top: 0;
  border-top: none;

  > button {
    min-height: 38px;
    border-radius: 20px;
    padding: 0 16px;
    font-size: 11px;
    line-height: 16px;
    letter-spacing: 0.08em;
  }
`

export const NoChaptersMessage = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 14px;
  font-style: italic;
`

export const BodyLoadingOverlay = styled.div<{ isVisible: boolean }>`
  position: absolute;
  inset: 0;
  display: ${({ isVisible }) => (isVisible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  pointer-events: none;
  background: transparent;
  z-index: 2;
`
